// Lifted from schedugram-client/react-src/components/ui/data-table/data-table-skeleton.tsx
import { cn } from "@/lib/utils";
import type { Column } from "./types";

interface DataTableSkeletonProps<T> {
  columns: Column<T>[];
  rowCount: number;
  showCellBorders?: boolean;
}

export function DataTableSkeleton<T>({
  columns,
  rowCount,
  showCellBorders = false,
}: DataTableSkeletonProps<T>) {
  return (
    <>
      {Array.from({ length: rowCount }).map((_, rowIndex) => (
        <tr key={`skeleton-${rowIndex}`} className="animate-pulse bg-white">
          {columns.map((column, colIndex) => (
            <td
              key={`skeleton-${rowIndex}-${column.id}`}
              className={cn(
                "px-4 py-4",
                showCellBorders && colIndex < columns.length - 1 && "border-r border-neutral-200",
                rowIndex < rowCount - 1 && "border-b border-neutral-200",
                column.cellClassName,
              )}
              style={{
                width: column.width,
                minWidth: column.minWidth,
                maxWidth: column.maxWidth,
              }}
            >
              <div
                className={cn(
                  "h-4 rounded bg-neutral-200",
                  colIndex % 3 === 0 && "w-3/4",
                  colIndex % 3 === 1 && "w-1/2",
                  colIndex % 3 === 2 && "w-2/3",
                )}
              />
            </td>
          ))}
        </tr>
      ))}
    </>
  );
}
